import React from "react";
import { Form } from "react-bootstrap";
import "./style.css";

interface ReclaimedMaterialsInfoProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const ReclaimedMaterialsInfo: React.FC<ReclaimedMaterialsInfoProps> = ({
  formData,
  setFormData,
}) => {
  return (
    <>
      <div className="reclaimed-materials-header">
        <Form.Label className="me-2" style={{ marginBottom: "4px" }}>
          Reclaimed Materials Information
        </Form.Label>
        <Form.Check
          type="checkbox"
          id="is-not-applicable-checkbox"
          label="N/A"
          className="na-checkbox"
          disabled
          defaultChecked={formData.ReclaimedMaterialsInfo.Reclaimed_Materials_Information__c}
        />
      </div>
      <div className="p-3">
        <p className="reclaimed-materials-description-label">
          Description of the organization&apos;s verification program for
          reclaimed materials
        </p>
        <span>
          (i.e. type of material sourced, material receipt/segregation, supplier
          audits)
        </span>

        <Form.Control
          as="textarea"
          rows={7}
          placeholder="Add a description..."
          className="mt-3"
          value={
            formData.ReclaimedMaterialsInfo.Description_of_the_organization_s_verifi__c || "--"
          }
          readOnly
        />
      </div>
    </>
  );
};

export default ReclaimedMaterialsInfo;
